// Libraries
import React from 'react';

// Components
import { CardBlock, CardText } from 'Components/flowChart/components/NodePreview/components/styled';
import { INodePreviewProps } from 'Components/flowChart/components/NodePreview/types';
import { INode } from 'Components/flowChart/types';

// Types
import { IMetadata as NodeWaitEventMetadata } from 'Components/flowChart/components/NodePreview/components/NodeWaitEvent/types';
import { IMetadata } from 'Components/flowChart/components/NodePreview/components/NodeWaitEventTimeout/types';

// Utils
import { deltaToContent } from 'Components/flowChart/utils';

const PATH = 'components/components/flowChart/components/Card/components/NodeWaitEventTimeout/index.tsx';

export interface INodeWaitEventTimeout extends INodePreviewProps<IMetadata> {}

const NodeWaitEventTimeout: React.FC<INodeWaitEventTimeout> = (props) => {
	try {
		const { node, flattenNodes } = props;
		const parentNode: INode<Partial<NodeWaitEventMetadata>> = flattenNodes[node.parentId!];

		if (parentNode) {
			const waitingTimeout = parentNode.metadata?.waitingTimeout;
			const deltaContent = deltaToContent(waitingTimeout?.delta!);

			if (deltaContent) {
				return (
					<CardBlock>
						<CardText>{`After: ${deltaContent}`}</CardText>
					</CardBlock>
				);
			}
		}

		return null;
	} catch (e) {
		props.onError?.(e, {
			component: PATH,
			action: 'render -> NodeWaitEventTimeout',
			args: { props },
		});

		return null;
	}
};

export default NodeWaitEventTimeout;
